// Aankooptunnel : winkelmandje (Cart.jsx) en checkout (Checkout.jsx).
// Vertaling van fr/tunnel.js — dezelfde sleutels, dezelfde volgorde.
// Toon : « je » in het winkelmandje, « u » vanaf de checkout (zoals in het Frans).
export default {
  // --- Winkelmandje (Cart.jsx) ---
  'tunnel.panier.seoTitre': 'Mijn winkelmandje',
  'tunnel.panier.seoDescription':
    'Bekijk uw Joyful Reveal-winkelmandje en reken veilig af met Stripe. Hebt u een kortingscode? Voer die hier opnieuw in.',
  'tunnel.panier.titre': '🛒 Jouw winkelmandje',
  'tunnel.panier.sousTitreVide':
    'Begin je avontuur door de puzzelstukjes te verzamelen',
  'tunnel.panier.sousTitreUn': 'Je hebt {n} stukje in je winkelmandje',
  'tunnel.panier.sousTitrePlusieurs': 'Je hebt {n} stukjes in je winkelmandje',
  'tunnel.panier.retireTitreUn':
    'Er is een artikel uit uw winkelmandje verwijderd',
  'tunnel.panier.retireTitrePlusieurs':
    'Er zijn artikelen uit uw winkelmandje verwijderd',
  'tunnel.panier.retireDetail':
    '{noms} — dit pack wordt niet meer aangeboden. Onze huidige packs vindt u in de',
  'tunnel.panier.retireDetailLien': 'shop',
  'tunnel.panier.progression': 'Verzameling in opbouw',
  'tunnel.panier.videTitre': 'Leeg winkelmandje',
  'tunnel.panier.videTexte':
    'Hier is nog niets te zien... voorlopig! Begin je avontuur en verzamel de puzzelstukjes.',
  'tunnel.panier.videCta': '🎯 Terug naar het avontuur',
  'tunnel.panier.langue': 'Taal:',
  'tunnel.panier.retirerDuPanier': 'Uit winkelmandje verwijderen',
  'tunnel.panier.sousTotal': 'Subtotaal',
  'tunnel.panier.reduction': 'Korting ({code})',
  'tunnel.panier.retirer': 'Verwijderen',
  'tunnel.panier.livraison': 'Verzending',
  'tunnel.panier.livraisonADeterminer': 'Nog te bepalen',
  'tunnel.panier.codePromo': 'Kortingscode',
  'tunnel.panier.appliquer': 'Toepassen',
  'tunnel.panier.promoAppliquee': 'Code "{code}" toegepast!',
  'tunnel.panier.total': 'Totaal',
  'tunnel.panier.offreSpeciale':
    'Speciale verzameling vrijgespeeld! Je bent dicht bij het grote geheim.',
  'tunnel.panier.continuerCollecter': '← Verder verzamelen',
  'tunnel.panier.procederPaiement': '🎯 Naar de betaling',

  // --- Checkout (Checkout.jsx) ---
  'tunnel.checkout.seoTitre': 'Betaling - Veilig afrekenen',
  'tunnel.checkout.seoDescription':
    'Rond uw aankoop van de Joyful Reveal-puzzel veilig af met Stripe. Snelle levering in Frankrijk en Europa.',
  'tunnel.checkout.chargement': 'Laden...',
  'tunnel.checkout.erreur': '❌ Fout: {message}',
  'tunnel.checkout.etape': 'Stap {n} / 3',
  'tunnel.checkout.sansCompte':
    '✅ U hoeft geen account aan te maken — uw e-mailadres volstaat om de bevestiging en de tracking van uw pakje te ontvangen.',
  'tunnel.checkout.dejaCompte': 'Hebt u al een account?',
  'tunnel.checkout.dejaCompteLien': 'Log in',
  'tunnel.checkout.dejaCompteFin': 'om uw bestellingen terug te vinden.',
  'tunnel.checkout.etape1Titre': '📍 Leveringsadres',
  'tunnel.checkout.champNomComplet': 'Volledige naam',
  'tunnel.checkout.champEmail': 'E-mail',
  'tunnel.checkout.champAdresse': 'Adres',
  'tunnel.checkout.champVille': 'Plaats',
  'tunnel.checkout.champCodePostal': 'Postcode',
  'tunnel.checkout.choisirPays': 'Kies een land',
  'tunnel.checkout.paysFR': 'Frankrijk',
  'tunnel.checkout.paysBE': 'België',
  'tunnel.checkout.paysLU': 'Luxemburg',
  'tunnel.checkout.paysDE': 'Duitsland',
  'tunnel.checkout.paysES': 'Spanje',
  'tunnel.checkout.paysIT': 'Italië',
  'tunnel.checkout.paysNL': 'Nederland',
  'tunnel.checkout.paysPT': 'Portugal',
  'tunnel.checkout.etape2Titre': '🚚 Leveringswijze',
  'tunnel.checkout.calculTarifs': 'Tarieven berekenen...',
  'tunnel.checkout.etapeSuivanteRequise': 'Volgende stap vereist',
  'tunnel.checkout.choisirPointRelaisTexte':
    'Kies het afhaalpunt waar u uw bestelling wilt ophalen',
  'tunnel.checkout.choisirPointRelaisBouton':
    '🗺️ KLIK HIER OM UW AFHAALPUNT TE KIEZEN',
  'tunnel.checkout.pointRelaisSelectionne': '✓ Afhaalpunt gekozen',
  'tunnel.checkout.modifier': 'Wijzigen',
  // De afhaalpuntkiezer is een extern script : het kan ontbreken (netwerk,
  // adblocker). Deze berichten vervangen Engelse alert()-vensters.
  'tunnel.checkout.selecteurIndisponible':
    'De kaart met afhaalpunten kon niet laden. Herlaad de pagina, en schakel bij aanhoudende problemen uw adblocker even uit tijdens het bestellen.',
  'tunnel.checkout.choisirTransporteurDabord':
    'Kies eerst een leveringswijze hierboven.',
  'tunnel.checkout.selecteurErreur':
    'De kaart met afhaalpunten reageerde niet. Probeer het zo meteen opnieuw.',
  // Leveringswijze bij elke optie : Sendcloud stuurt er een tiental terug, en
  // de productnaam zegt niet waar het pakje aankomt.
  'tunnel.checkout.modePointRelais': '📍 Afhaalpunt',
  'tunnel.checkout.modeDomicile': '🏠 Thuislevering',
  'tunnel.checkout.livraisonDomicileTexte':
    '✓ Rechtstreeks geleverd op uw adres: {adresse}',
  // Verschijnt alleen wanneer de bijdrage echt bestaat (zie fr/tunnel.js).
  'tunnel.checkout.participation': '💚 Wij nemen {montant} € van deze verzending op ons',
  'tunnel.checkout.portSansMarge':
    'Het getoonde tarief is dat van de vervoerder, tot op de cent — wij rekenen er niets bovenop.',
  'tunnel.checkout.indispoTitre':
    '⏳ Levering naar dit land is tijdelijk niet mogelijk',
  'tunnel.checkout.indispoTexte':
    'Op dit moment biedt geen enkele vervoerder ons dit traject aan. We werken eraan om het open te stellen — controleer intussen het ingevoerde adres (postcode en plaats), kies een ander land van levering, of schrijf ons: samen vinden we een oplossing.',
  'tunnel.checkout.indispoModifierAdresse': '← Adres wijzigen',
  'tunnel.checkout.indispoContact': '💬 Neem contact op',
  'tunnel.checkout.voirPlusOptions': '↓ De {n} andere vervoerders tonen',
  'tunnel.checkout.voirMoinsOptions': '↑ Minder opties tonen',
  'progression.complete': '✨ ONTHULLING COMPLEET! ✨',
  'progression.restant': 'Nog {n} stukjes te ontdekken',
  // Le tunnel de commande compte des ÉTAPES : y afficher « Plus que 23
  // pièces à découvrir » juste au-dessus du bouton de paiement inquiétait
  // l'acheteur au lieu de le rassurer.
  'progression.etapeRestante': "Nog {n} stap voor de betaling",
  'progression.etapesRestantes': "Nog {n} stappen voor de betaling",
  'progression.pretAPayer': "Laatste stap: de betaling",
  'tunnel.panier.etape': "Uw winkelmandje",
  'tunnel.checkout.tarifsAttenteLongue':
    'Een ogenblik, de verbinding met de vervoerder duurt wat langer dan gewoonlijk.',
  'tunnel.checkout.tarifsReprise':
    'De vervoerder antwoordt niet, we proberen het opnieuw ({n}/{total})…',
  'tunnel.checkout.tarifsErreurTitre':
    '⚠️ De verzendkosten konden niet worden berekend',
  'tunnel.checkout.tarifsErreurTexte':
    'We hebben het drie keer geprobeerd, zonder resultaat. Het ligt niet aan uw land, maar aan onze verbinding met de vervoerder. Start de berekening opnieuw — blijft het misgaan, schrijf ons dan en we ronden de bestelling samen met u af.',
  'tunnel.checkout.tarifsReessayer': '↻ Opnieuw proberen',
  'tunnel.checkout.etape3Titre': '💳 Betaling',
  'tunnel.checkout.redirectionStripe':
    'U wordt doorgestuurd naar een beveiligde betaalpagina van Stripe.',
  'tunnel.checkout.redirection': 'Doorsturen...',
  'tunnel.checkout.procederPaiement': 'Veilig afrekenen →',
  'tunnel.checkout.retour': '← Terug',
  'tunnel.checkout.continuer': 'Verder →',
  'tunnel.checkout.recapitulatif': '📦 Overzicht',
  'tunnel.checkout.recapLivraison': '🚚 Verzending ({nom})',
  'tunnel.checkout.recapReduction': '🏷️ Korting ({code})',
  'tunnel.checkout.total': 'Totaal:',
  'tunnel.checkout.paiementReussi': 'Betaling geslaagd!',
};
